/**
 * create by zpf 2018-07-27
 * 全局组件库,存储项目所需使用的组件
 */
class componentModel {
  constructor () {
    this.components = {}   // 全局依赖组件
    this.appComponents = {}  // 单元依赖组件
  }

  /**
   * 注册全局依赖组件
   * @param name 组件名称
   * @param component 主键对象
   */
  registerComponent (componentName, component) {
    if (!this.components[componentName]) {
      this.components[componentName] = component
    } else {
      console.log(`${componentName}组件已注册`)
    }
  }

  /**
   * 注册单元依赖组件
   * @param appName 单元名称
   * @param componentName 组件名称
   * @param component 组件对象
   */
  registerAppComponent (appName, componentName, component) {
    // 判断单元依赖组件对象中是否已有对象,有则在对象中添加,无则赋值一个空对象进行添加
    this.appComponents[appName] = this.appComponents[appName] || {}
    this.appComponents[appName].components = this.appComponents[appName].components || {}
    if (!this.appComponents[appName].components[componentName]) {
      this.appComponents[appName].components[componentName] = component
    } else {
      console.log(`${appName}:${componentName}组件已注册`)
    }
  }

  /**
   * 批量注册全局组件
   * @param components 组件对象数组
   */
  registerComponents (components) {
    if (!components || components.length === 0) return
    components.forEach(c => this.registerComponent(c.name, c.component))
  }

  /**
   * 获取组件
   * @param appName 单元名称
   * @param componentName 主键闽南工程
   * @return {*}
   */
  getComponent (appName, componentName) {
    // 如果组件名称为空,则报错
    if (!componentName)
      throw '组件名称不能为空!'

    // 如果是原生标签,则剔除前两位标识列,返回原生标签
    if (componentName.substring(0, 2) === '::') {
      if (componentName.substr(2))
        return componentName.substr(2)
      else
        throw `原生标签内容为空,::`
    }

    // 取出组件名称,如果是多级组件,则firstSeg存储一级组件名称
    const nameSegs = componentName.split('.'),
      firstSeg = nameSegs[0]

    // 判断一级组件名称是否在单元组件依赖中存在
    if (this.appComponents && this.appComponents[appName]
      && this.appComponents[appName].components
      && this.appComponents[appName].components[firstSeg]) {
      let com = this.appComponents[appName].components[componentName]

      // 如果存在,则向下查找,返回最底层组件
      if (com && nameSegs.length > 1)
        com = this.findChild(com, nameSegs)

      if (com) return com
    }

    // 在全局组件依赖中查找
    let component = this.components[firstSeg]

    if (component && nameSegs.length > 1) {
      component = this.findChild(component, nameSegs)
    }

    if (!component) {
      debugger
      throw `没有组件. name: ${componentName}`
    }

    return component
  }

  /**
   * 获取二级组件
   * @param component 组件对象
   * @param nameSegs 组件名称数组
   * @return {*}
   */
  findChild (component, nameSegs) {
    for (let s of nameSegs.slice(1)) {
      if (!component[s]) {
        component = undefined
        return
      }
      component = component[s]
    }
    return component
  }
}

const componentInstance = new componentModel()

export default componentInstance


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/componentModel.js